import { Badge } from '@/components/ui/badge'
import type { UserInfo as UserInfoType, GreenmateInfo as GreenmateInfoType, Character } from '@/types'
import { CHARACTER_INFO } from '@/types/user'
import { formatDateTime } from '@/utils/formatDate'

interface UserInfoProps {
  user: UserInfoType | null
  greenmate?: GreenmateInfoType | null
}

export function UserInfo({ user, greenmate }: UserInfoProps) {
  if (!user) return null

  // Map greenmate_type to Character type
  const character = greenmate?.greenmate_type?.toUpperCase() as Character | undefined

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted text-3xl">
          {character && CHARACTER_INFO[character]
            ? CHARACTER_INFO[character].emoji
            : '👤'}
        </div>
        <div>
          <h2 className="text-xl font-bold">
            {user.nickname || greenmate?.name || '익명'}
          </h2>
          {user.email && (
            <p className="text-sm text-muted-foreground">{user.email}</p>
          )}
        </div>
      </div>

      <div className="space-y-2">
        <div className="flex justify-between">
          <span className="text-muted-foreground">사용자 ID</span>
          <span className="font-mono text-sm">{user.id}</span>
        </div>

        <div className="flex justify-between">
          <span className="text-muted-foreground">캐릭터</span>
          {character && CHARACTER_INFO[character] ? (
            <Badge variant="secondary">
              {CHARACTER_INFO[character].emoji}{' '}
              {CHARACTER_INFO[character].name}
            </Badge>
          ) : (
            <span>-</span>
          )}
        </div>

        <div className="flex justify-between">
          <span className="text-muted-foreground">언어</span>
          <Badge variant="outline">{user.language.toUpperCase()}</Badge>
        </div>

        <div className="flex justify-between">
          <span className="text-muted-foreground">OAuth 제공자</span>
          <span>{user.oauth_provider}</span>
        </div>

        <div className="flex justify-between">
          <span className="text-muted-foreground">생성일</span>
          <span className="text-sm">{formatDateTime(user.created_at)}</span>
        </div>

        {greenmate && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">그린메이트 생성일</span>
            <span className="text-sm">{formatDateTime(greenmate.created_at)}</span>
          </div>
        )}
      </div>
    </div>
  )
}
